// extracted by mini-css-extract-plugin
module.exports = {"column":"Board_column__2kOrf","board":"Board_board__2A-b9"};